import React from 'react';
import { BookOpenIcon, SparklesIcon, GraduationCapIcon } from 'lucide-react';
import { Accent, SectionHeading } from './SectionHeading';
import { solutionBenefits } from '../../data/content';
import { MOCKUP_URL } from '../../data/images';
const icons = [BookOpenIcon, SparklesIcon, GraduationCapIcon];
export function SolutionSection() {
  return <section aria-labelledby="solution-heading" className="bg-brand-ivory px-5 py-16 lg:px-8 lg:py-24" data-id="element-136" data-mp="1ohpjgv77jxa7">
      <div className="mx-auto max-w-5xl" data-id="element-137" data-mp="1thlo8wnqbsqt">
        <SectionHeading id="solution-heading" title={<>
              Ein digitales System. Sechs Fachbände. <Accent data-id="element-139" data-mp="23e6t9hzr13un">Mehr Struktur für deine Schulungen.</Accent>
            </>} body={<>
              <strong className="font-semibold text-brand-charcoal" data-id="element-140" data-mp="27d63ni491sth">NAIL EDUCATOR READY™</strong> verbindet fachliche
              Grundlagen, technische Anleitungen, visuelle Fehleranalysen und didaktische Hilfsmittel in einer
              digitalen Sammlung. Statt jedes Thema von Grund auf neu zusammenzustellen, kannst du auf übersichtlich
              aufbereitete Inhalte zurückgreifen und sie als Grundlage für deine eigene Unterrichtsplanung nutzen.
            </>} data-id="element-138" data-mp="1ye2k6d167beg" />

        <div className="mt-12 grid items-center gap-10 lg:grid-cols-[1.15fr_1fr]" data-id="element-141" data-mp="3mzx3ysa467su">
          <img src={MOCKUP_URL} alt="Das komplette System Nail Educator Ready" width={1536} height={1024} loading="lazy" decoding="async" className="mx-auto block w-full max-w-[560px] object-contain" style={{
          filter: 'drop-shadow(0 30px 36px rgba(78, 49, 108, 0.22))'
        }} data-id="element-142" data-mp="3i4hoxx0de5uu" />

          <ul className="space-y-6" role="list" data-id="element-143" data-mp="4n0f6bioo6qj">
            {solutionBenefits.map((benefit, index) => {
            const Icon = icons[index];
            return <li key={benefit.title} className="flex items-start gap-4" data-id="element-144" data-mp="2pdretkq7fte5" data-mpi={index}>
                  <span className="flex h-11 w-11 flex-none items-center justify-center rounded-full bg-brand-lavender" data-id="element-145" data-mp="1heu1b243udsd">
                    <Icon className="h-5 w-5 text-brand-forest" strokeWidth={1.75} aria-hidden="true" data-id="element-146" data-mp="1lgxcrqqrxidn" />
                  </span>
                  <span data-id="element-147" data-mp="17fuod7cb3vzk">
                    <span className="block font-display text-[1.35rem] font-bold leading-tight text-brand-charcoal" data-id="element-148" data-mp="17iqnv03sysq4">
                      {benefit.title}
                    </span>
                    <span className="mt-1 block text-[15px] leading-relaxed text-brand-charcoal/70" data-id="element-149" data-mp="xp9v7zfejjo1">{benefit.text}</span>
                  </span>
                </li>;
          })}
          </ul>
        </div>
      </div>
    </section>;
}